import type { PlacedOrderResponse, PlaceOrderRequest } from 'apiConnector/secondary-market/cp-order/model';

export type SecondaryMarketCpOrderOrderActions = SecondaryMarketCpOrderPlacementActions;

type SecondaryMarketCpOrderPlacementActions =
  | SecondaryMarketCpOrderPlacementRequested
  | SecondaryMarketCpOrderPlacementReceived
  | SecondaryMarketCpOrderPlacementFailed
  | SecondaryMarketCpOrderPlacementClose
  | SecondaryMarketCpOrderByOrderIdReloadRequested;

/////////////////////////////////////////////
export function secondaryMarketCpOrderPlacementRequested(tabId: string, request: PlaceOrderRequest) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_PLACEMENT_REQUESTED' as const,
    tabId,
    request,
  };
}

export type SecondaryMarketCpOrderPlacementRequested = ReturnType<typeof secondaryMarketCpOrderPlacementRequested>;

/////////////////////////////////////////////

export function secondaryMarketCpOrderPlacementReceived(tabId: string, data: PlacedOrderResponse) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_PLACEMENT_RECEIVED' as const,
    tabId,
    ...data,
  };
}

export type SecondaryMarketCpOrderPlacementReceived = ReturnType<typeof secondaryMarketCpOrderPlacementReceived>;

/////////////////////////////////////////////

export function secondaryMarketCpOrderPlacementFailed(
  tabId: string,
  isTimeout: boolean,
  errorMessage?: string,
  timeout?: number,
) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_PLACEMENT_FAILED' as const,
    tabId,
    isTimeout,
    errorMessage,
    timeout,
  };
}

export type SecondaryMarketCpOrderPlacementFailed = ReturnType<typeof secondaryMarketCpOrderPlacementFailed>;

/////////////////////////////////////////////

export function secondaryMarketCpOrderPlacementClose(tabId: string) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_CLOSE' as const,
    tabId,
  };
}

export type SecondaryMarketCpOrderPlacementClose = ReturnType<typeof secondaryMarketCpOrderPlacementClose>;

export function secondaryMarketCpOrderByOrderIdReloadRequested(orderId: string) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_BY_ORDER_ID_RELOAD_REQUESTED' as const,
    orderId,
  };
}

export type SecondaryMarketCpOrderByOrderIdReloadRequested = ReturnType<
  typeof secondaryMarketCpOrderByOrderIdReloadRequested
>;
